module.exports = __webpack_public_path__ + "static/media/日语朗读？？傲娇台词版五十音图.a1c3e338.flv";